import { MarkupDasharrayType, MarkupLinecapType, type ILayerProps, type IMarkupLayerProps } from '@/version-types';

/** Markup 图层当前支持的线型组合，顺序与属性面板保持一致。 */
export const MARKUP_DASHARRAY_OPTIONS = [
    { value: MarkupDasharrayType.Solid, linecap: MarkupLinecapType.Square },
    { value: MarkupDasharrayType.Solid, linecap: MarkupLinecapType.Round },
    { value: MarkupDasharrayType.Square, linecap: MarkupLinecapType.Square },
    { value: MarkupDasharrayType.Dot, linecap: MarkupLinecapType.Round },
    { value: MarkupDasharrayType.Dashed, linecap: MarkupLinecapType.Round },
] as const;

const BRUSH_DASHARRAY_TO_MARKUP_MAP: Readonly<Record<string, MarkupDasharrayType>> = {
    '3,2': MarkupDasharrayType.Square,
    '2,2,6,2': MarkupDasharrayType.Dashed,
};

/** 将误写入 Markup 图层的 Brush 线型值映射回 Markup 枚举，未知值保持不变。 */
export function normalizeMarkupDasharray(dasharray: string) {
    return BRUSH_DASHARRAY_TO_MARKUP_MAP[dasharray] ?? dasharray;
}

/** 归一化 Markup 图层线型。 */
export function normalizeMarkupLayerDasharray(layer: ILayerProps) {
    const data = layer.data as IMarkupLayerProps;
    if (!data.fill) return layer;
    data.fill.dasharray = normalizeMarkupDasharray(data.fill.dasharray) as MarkupDasharrayType;
    return layer;
}
